// `Symbol.replace` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.replace
require('../internals/define-well-known-symbol')('replace');
